import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3eopd3scey: FaireBrandEntity = {
  token: "b_3eopd3scey",
  type: "brand",
  name: "ACCITY",
  avatarUrl: "https://cdn.faire.com/fastly/36baf1c986a18b2f147493739d714a486a6e232fcf837367a64b8a9e94b8b7df.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/9ef463dadaf7d163d924b64ee9bc1538a69964f4e93c64cffd1884cadaa4c8d3.png",
  logoUrl: "https://cdn.faire.com/fastly/36baf1c986a18b2f147493739d714a486a6e232fcf837367a64b8a9e94b8b7df.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/9ef463dadaf7d163d924b64ee9bc1538a69964f4e93c64cffd1884cadaa4c8d3.png",
  location: "Houston, TX, USA",
  minimumOrderDollars: 150,
  rating: 4.6,
  reviewCount: 1127,
  isInsider: true,
  description: "ACCITY is based in the heart of the fashion industry in Los Angeles. The company was founded in 2020 with an ambition to inspire and provide influential fashion to the world. our brand is operated by professional design tea, sewing team and manufacture team. \nAccity's highest goal is our customers' satisfaction with our high quality and well-designed accessories.\nWe always try to provide high quality and the latest fashion accessories for our customer.",
  meta: {
    source: "api",
    importedAt: "2026-10-07T18:32:29.895Z",
    importedBy: "entity-db-cli"
  }
};
